<div class="content-box">
    <p-chart #chart type="pie" [data]="data" [options]="options" [height]="height" [width]="width"> </p-chart>
    <div #legend class="legend"></div>
    <div class="no-data-chart" *ngIf="emptyChart">Not enough data</div>
</div>
